import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import {
  getFormFields,
  getFormTitle,
  getButtonTitle,
  useUtilitySetupVerifyPhone,
  SrUtilitySetupVerifyPhoneErrorMessage,
} from 'client/components/SrUtilitySetup/SrUtilitySetupVerifyPhone';
import SrText from 'client/components/SrText';
import SrBox from 'client/components/SrBox';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_THEME_ADOBE_GREY,
} from 'client/components/SrButton/SrButton';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';

const SrUtilitySetupLazyLoginModal = ({ utilityActivation, callbackFunction, onClose }) => {
  const { formId, phone, apiError, codeSent, setCodeSent, onRequestCode, onSubmit } =
    useUtilitySetupVerifyPhone({
      onSuccess: () => {
        callbackFunction();
      },
    });

  return (
    <Formik
      onSubmit={onSubmit}
      initialValues={createInitialValues({
        formFields: getFormFields({ formId }),
        defaultValues: {
          phone: '',
          code: '',
          userPhone: utilityActivation.user.phone,
        },
      })}
      validate={(formValues) => {
        const formFields = getFormFields({ formId });
        return createFormValidationFn(formFields)(formValues);
      }}
      render={(formikBag) => {
        const formFields = getFormFields({
          formId,
          codeSent,
          onClickResendCode: () => {
            onRequestCode({ phone });
            setCodeSent(true);
            setTimeout(() => {
              setCodeSent(false);
            }, 3000);
          },
        });
        const formTitle = getFormTitle({ formId });
        const buttonTitle = getButtonTitle({ formId });

        return (
          <SrSimpleMessageModal
            underline
            maxWidth={375}
            messageClassName="noAlign"
            theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
            headline={formTitle}
            message={
              <div>
                <SrText font="greycliff" weight="600" display="block" align="center">
                  Use phone ending in (***) ***-{utilityActivation.user?.phone?.slice(-4)}
                </SrText>
                {formFields.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                    theme={SR_FIELD_THEME_ADOBE}
                  />
                ))}
                <SrBox marginTop="10px">
                  {apiError && <SrUtilitySetupVerifyPhoneErrorMessage error={apiError} />}
                </SrBox>
              </div>
            }
            srMultiButtons={[
              {
                buttonText: buttonTitle,
                onButtonClick: formikBag.handleSubmit,
                buttonTheme: SR_BUTTON_THEME_ADOBE_GREEN,
              },
              onClose && {
                buttonText: 'Cancel',
                onButtonClick: onClose,
                buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
              },
            ].filter(Boolean)}
          />
        );
      }}
    />
  );
};

SrUtilitySetupLazyLoginModal.propTypes = {
  utilityActivation: PropTypes.object,
  callbackFunction: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrUtilitySetupLazyLoginModal.displayName = 'SrUtilitySetupLazyLoginModal';

export default SrUtilitySetupLazyLoginModal;
